import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  resetApplication({ commit }, data) {
    commit(types.RESET_APPLICATION, data)
  },
  setApplicationData({ commit }, data) {
    commit(types.SET_APPLICATION_DATA, data)
  },
  resetAssessment({ commit }, data) {
    commit(types.RESET_ASSESSMENT, data)
  },
  setAssessmentData({ commit }, data) {
    commit(types.SET_ASSESSMENT_DATA, data)
  },
  resetSetting({ commit }, data) {
    commit(types.RESET_SETTING, data)
  },
  setSettingData({ commit }, data) {
    commit(types.SET_SETTING_DATA, data)
  },
  setSelectedBiTemplate({ commit }, template) {
    commit(types.SET_BITEMPLATE, template)
  },
  setSelectedBiTemplateData({ commit }, data) {
    commit(types.SET_BITEMPLATE_DATA, data)
  },
  async getStateProvinces({ commit }) {
    const r = await http.get(`v2/settings/stateprovinces`)
    commit(types.SET_STATEPROVINCES, r.data.data)
    return r.data.data
  },
  async getTimezones({ commit }, id) {
    const r = await http.get(`v2/settings/timezones`)
    commit(types.SET_TIMEZONES, r.data.data)
    return r.data.data
  },
  async getApplications({ commit }, data) {
    commit(types.RESET_PAGER)
    const r = await http.get(`v2/settings/applications`, {
      params: data,
    })
    commit(types.SET_APPLICATIONS, r.data.data)
    return r.data.data
  },
  async getApplication({ commit }, id) {
    const r = await http.get(`v2/settings/application/${id}`)
    commit(types.SET_APPLICATION, r.data.data)
    return r.data.data
  },
  async saveApplication({ commit }, data) {
    let r = null
    r = await http.post('v2/settings/saveApplication', data).catch((error) => {
      return { data: { data: null, error: error.response.data.message } }
    })
    return r.data
  },
  async removeApplication({ commit }, id) {
    const r = await http.delete(`v2/settings/removeApplication/${id}`)
    return r.data.data
  },
  async getAssessmentTypes({ commit }, id) {
    const r = await http.get(`v2/settings/assessmentTypes`)
    commit(types.SET_ASSESSMENT_TYPES, r.data.data)
    return r.data.data
  },
  async getAssessments({ commit }, data) {
    commit(types.RESET_PAGER)
    const r = await http.get(`v2/settings/assessments`, {
      params: data,
    })
    commit(types.SET_ASSESSMENTS, r.data.data)
    return r.data.data
  },
  async getAssessment({ commit }, id) {
    const r = await http.get(`v2/settings/assessment/${id}`)
    commit(types.SET_ASSESSMENT, r.data.data)
    return r.data.data
  },
  async saveAssessment({ commit }, data) {
    let r = null
    r = await http.post('v2/settings/saveAssessment', data).catch((error) => {
      return { data: { data: null, error: error.response.data.message } }
    })
    return r.data
  },
  async removeAssessment({ commit }, id) {
    const r = await http.delete(`v2/settings/removeAssessment/${id}`)
    return r.data.data
  },
  async getAssessmentNorms({ commit }, data) {
    const r = await http.get(`v2/settings/getSettings`, {
      params: data,
    })
    commit(types.SET_NORMS, r.data.data)
    return r.data.data
  },
  async getSettings({ commit }, data) {
    commit(types.RESET_PAGER)
    const r = await http.get(`v2/settings/getSettings`, {
      params: data,
    })
    commit(types.SET_SETTINGS, r.data.data)
    return r.data.data
  },
  async getSetting({ commit }, data) {
    const r = await http.get(`v2/settings/getSetting`, {
      params: data,
    })
    commit(types.SET_SETTING, r.data.data)
    return r.data.data
  },
  async saveSetting({ commit }, data) {
    let r = null
    r = await http.post('v2/settings/saveSetting', data).catch((error) => {
      return { data: { data: null, error: error.response.data.message } }
    })
    return r.data
  },
  async removeSetting({ commit }, id) {
    const r = await http.delete(`v2/settings/removeSetting/${id}`)
    return r.data.data
  },
  async getBiTemplates({ commit }, data) {
    const r = await http.get(`v2/settings/getSetting`, {
      params: data,
    })
    commit(types.SET_BITEMPLATES, r.data.data)
    return r.data.data
  },
}
